import Home from 'pages/blog/page';

const NBABlogPage = () => <Home sportCategory="nba" />;
export default NBABlogPage;
